import { render, staticRenderFns } from "./MainPagination.vue?vue&type=template&id=49804c7d&scoped=true&"
import script from "./MainPagination.vue?vue&type=script&lang=js&"
export * from "./MainPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49804c7d",
  null
  
)

export default component.exports